module.exports = __webpack_public_path__ + "static/media/server1.b3db2266.png";